import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as styles from './Previews.scss';

var ThankYouPreview = /*#__PURE__*/function (_Component) {
  _inherits(ThankYouPreview, _Component);

  var _super = _createSuper(ThankYouPreview);

  function ThankYouPreview() {
    _classCallCheck(this, ThankYouPreview);

    return _super.apply(this, arguments);
  }

  _createClass(ThankYouPreview, [{
    key: "render",
    value: function render() {
      var formValues = this.props.formValues;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.previewWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.headline
      }, formValues.thankYouHeadline), /*#__PURE__*/React.createElement("p", {
        className: styles.thankYouDescription
      }, formValues.thankYouDescription));
    }
  }]);

  return ThankYouPreview;
}(Component);

export { ThankYouPreview as default };